import ChallengeTeamEnterBox from "./ChallengeTeamEnterBox";
import {ApplicationConsent, ApplicationInput, ApplicationSelection} from "./ChallengeTeamCreateApplicationItem";
import challengeStyles from "../../common/css/Challenge.module.css";
import commonStyles from "../../common/css/Common.module.css";
import applicationStyles from "./ChallengeTeamCreateApplicationStyle.module.css";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import EnterItem from "../common/EnterItem";
import RadioItem from "../common/RadioItem";
import useKeepDoubleClick from "../../common/hook/useKeepDoubleClick";
import {useDialog} from "../../common/hook/DialogContext";

const ChallengeTeamCreateApplication = ({uid, challengeRefresh, setChallengeRefresh}) => {
    const [items, setItems] = useState([]);
    const [name, setName] = useState('');
    const [intro, setIntro] = useState('');
    const [teamCondition, setTeamCondition] = useState('');
    const [values, setValues] = useState([]);
    const [clicked, preventDoubleClick] = useKeepDoubleClick();
    const {addAlert, addConfirm} = useDialog();
    const navigate = useNavigate();
    const conditionValues = [
        "모두", "임상의만", "개발자만", "임상의+개발자"
    ];

    const conditionHandle = (e) => {
        setTeamCondition(e.target.value);
        if(e.target.value === teamCondition) {
            e.target.checked = true;
        }
    };

    const getChallengeApplicationItems = () => {
        fetch(`/v1/challenge-team-application/${uid}`)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    return response.json().then(json => {
                        addAlert(json.message,
                            () => navigate(`/challenge/${uid}/team`)
                        );
                    })
                }
            })
            .then((json) => {
                setItems(json);
            });
    }

    useEffect(() => {
        getChallengeApplicationItems();
    }, []);

    useEffect(() => {
        const initialState = [];
        items.forEach((item, idx) => {
            initialState[idx] = {
                itemUid: item.itemUid,
                value:
                    item.itemType === "INPUT" ?
                        ''
                        :
                        item.itemType === "SELECTION" ?
                            0
                            :
                            false
            };
        });
        setValues(initialState);
    }, [items]);

    const insertData = () => {
        addConfirm(
            "팀 만들기 신청을 하시겠습니까?",
            () => {
                fetch("/v1/challenge-team", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    method: "post",
                    credentials: "include",
                    redirect: "follow",
                    body: JSON.stringify({
                        challengeUid: uid,
                        name: name,
                        intro: intro,
                        teamCondition: teamCondition,
                        saveTeamApplicationItemValueRequests: values,
                    }),
                }).then((response) => {
                    clicked.current = false;
                    if (response.ok) {
                        addAlert(
                            "등록 되었습니다.",
                            () => navigate(`/challenge/${uid}/team`)
                        );
                        setChallengeRefresh(!challengeRefresh);
                    } else if (response.status === 400 || response.status === 409) {
                        response.json().then(json => {
                            addAlert(json.message);
                        })
                    } else if (response.status === 401) {
                        response.json().then(json => {
                            addAlert(
                                json.message,
                                () => navigate(`/challenge/${uid}/team`)
                            );

                        })
                    }else {
                        throw new Error("등록할 수 없습니다. 다시 시도해주세요.");
                    }
                }).catch(e => {
                    addAlert(e.message);
                });
            },
            () => {
                clicked.current = false;
            }
        )
    };

    const validation = () => {
        if (name.trim() === "") {
            addAlert("팀명을 입력해주세요.");
            return;
        }

        if (intro.trim() === "") {
            addAlert("팀 소개를 입력해주세요.");
            return;
        }

        if (teamCondition.trim() === "") {
            addAlert("팀원 모집 조건을 선택해주세요.");
            return;
        }

        for (let i = 0; i < values.length; i++) {
            if (typeof values[i].value === "string") {
                if (values[i].value.trim() === "") {
                    addAlert("입력 하지 않은 신청정보가 존재합니다.");
                    return;
                }
            } else if (typeof values[i].value === "boolean") {
                if (!values[i].value) {
                    addAlert("동의 하지 않은 신청정보가 존재합니다.");
                    return;
                }
            } else {
                if (!values[i].value || values[i].value === 0) {
                    addAlert("선택 하지 않은 신청정보가 존재합니다.");
                    return;
                }
            }
        }

        return true;
    };
    const submit = () => {
        preventDoubleClick(insertData, validation);
    };

    return (
        <ChallengeTeamEnterBox>
            <div className={challengeStyles.enter_wrap}>
                <EnterItem addClass={`${challengeStyles.enter_item} ${applicationStyles.enter_item}`}>
                    <label htmlFor="team_name" className={challengeStyles.item_title}>팀명을 입력해 주세요.</label>
                    <div className={`${commonStyles.enter} ${challengeStyles.enter}`}>
                        <input
                            id={"team_name"}
                            type={"text"}
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                            maxLength={60}
                        />
                    </div>
                </EnterItem>
                <EnterItem addClass={`${challengeStyles.enter_item} ${applicationStyles.enter_item}`}>
                    <label htmlFor="team_intro" className={challengeStyles.item_title}>팀 소개를 입력해 주세요.</label>
                    <div className={`${commonStyles.enter} ${challengeStyles.enter}`}>
                        <input
                            id={"team_intro"}
                            type={"text"}
                            onChange={(e) => setIntro(e.target.value)}
                            value={intro}
                            maxLength={60}
                        />
                    </div>
                </EnterItem>
                <EnterItem addClass={`${challengeStyles.enter_item} ${applicationStyles.enter_item}`}>
                    <div className={challengeStyles.item_title}>팀원 모집 조건을 선택해 주세요.</div>
                    <div className={`${commonStyles.enter} ${challengeStyles.enter}`}>
                        <div className={challengeStyles.option_list}>
                            {conditionValues.map((conditionValue, idx) => (
                                <RadioItem key={`conditionValue${idx}`} addClass={challengeStyles.radio_item}>
                                    <label>
                                        <input
                                            id={`team_option`}
                                            name={`team_option`}
                                            type="radio"
                                            value={conditionValue}
                                            onClick={(e) => conditionHandle(e)}
                                            checked={conditionValue === teamCondition}
                                        />
                                        <span>{conditionValue}</span>
                                    </label>
                                </RadioItem>
                            ))}
                        </div>
                    </div>
                </EnterItem>


                {items.map((item, idx) => (
                    <>
                        {item.itemType === "INPUT" && (
                            <ApplicationInput
                                key={item.itemUid}
                                item={item}
                                values={values}
                                setValues={setValues}
                                valueIdx={idx}
                            />
                        )}

                        {item.itemType === "SELECTION" && (
                            <ApplicationSelection
                                key={item.itemUid}
                                item={item}
                                values={values}
                                setValues={setValues}
                                valueIdx={idx}
                            />
                        )}

                        {item.itemType === "CONSENT" && (
                            <ApplicationConsent
                                key={item.itemUid}
                                item={item}
                                values={values}
                                setValues={setValues}
                                valueIdx={idx}
                            />
                        )}
                    </>
                ))}
            </div>

            <div className={challengeStyles.bottom_btn_wrap}>
                <button type="button" className={`${commonStyles.cc_btn} ${challengeStyles.cc_btn} ${commonStyles.bg_white}`} onClick={() => navigate(-1)}>
                    <span>이전</span>
                </button>
                <button type="button" className={`${commonStyles.cc_btn} ${challengeStyles.cc_btn}`} onClick={submit}>
                    <span>신청</span>
                </button>
            </div>
        </ChallengeTeamEnterBox>
    )
}

export default ChallengeTeamCreateApplication;